/* eslint-disable import/no-cycle */
import {BaseWidgetConfig} from '../shared/widgets/baseWidgetConfig';
import i18n from '../../i18n/i18n';
import WidgetSettingFormField from '../shared/widgets/WidgetSettingFormField';
import {ValidationRules} from '../../utils/validationRules';

export class StateHistoryWidgetConfig extends BaseWidgetConfig {
  // eslint-disable-next-line class-methods-use-this
  get tabs() {
    return [
      {
        key: 'settings',
        label: i18n.t('widget.WidgetSettingsModal.settingConfigTabTitle'),
      },
    ];
  }

  settings = [
    {
      id: 'timelineLength',
      label: i18n.t('state.historyWidget.settings.timelineLength.label'),
      type: WidgetSettingFormField.fieldTypes.Number,
      defaultValue: 24,
      unit: i18n.t('state.historyWidget.settings.timelineLength.unit'),
      validations: [
        ValidationRules.required,
        ValidationRules.greaterThanOrEqualTo(1),
        ValidationRules.lessThanOrEqualTo(24),
      ],
    },
    {
      id: 'enableTimeline',
      label: i18n.t('state.historyWidget.settings.enableTimeline'),
      type: WidgetSettingFormField.fieldTypes.Boolean,
      defaultValue: true,
      validations: [ValidationRules.required],
    },
    {
      id: 'enableOperationState',
      label: i18n.t('state.historyWidget.settings.enableOperationState'),
      type: WidgetSettingFormField.fieldTypes.Boolean,
      defaultValue: true,
      validations: [ValidationRules.required],
    },
    {
      id: 'enableWorkplaceState',
      label: i18n.t('state.historyWidget.settings.enableWorkplaceState'),
      type: WidgetSettingFormField.fieldTypes.Boolean,
      defaultValue: true,
      validations: [ValidationRules.required],
    },
    {
      id: 'showInterruptionsMinDuration',
      label: i18n.t('state.historyWidget.settings.showInterruptionsMinDuration.label'),
      type: WidgetSettingFormField.fieldTypes.Number,
      unit: i18n.t('state.historyWidget.settings.showInterruptionsMinDuration.unit'),
      defaultValue: 0,
      validations: [ValidationRules.required, ValidationRules.greaterThanOrEqualTo(0), ValidationRules.number],
    },
  ];
}
